// Fetch list

export const FETCH = 'reportCustomerWeeklyPlans.FETCH'
export const FETCH_STARTED = 'reportCustomerWeeklyPlans.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCustomerWeeklyPlans.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCustomerWeeklyPlans.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCustomerWeeklyPlans.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportCustomerWeeklyPlans.CLEAR'

// Export

export const EXPORT = 'reportCustomerWeeklyPlans.EXPORT'
export const EXPORT_FULFILLED = 'reportCustomerWeeklyPlans.EXPORT_FULFILLED'
